export default __webpack_public_path__ + "static/Inter-Bold-e27ffc5941b78cb948a1bb4c2354add2.woff2";